import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useThemeComponents } from '../../../../themes';

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;

type QRCodeStepProps = {
    qrcodeUri: string;
    previous?: () => void;
    next?: () => void;
};

const QRCodeStep = ({ qrcodeUri, previous, next }: QRCodeStepProps) => {
    const { t } = useTranslation('userSelf');
    const { Button } = useThemeComponents();

    return (
        <div>
            <Typography.Text style={{ fontSize: '16px' }}>
                {t('userSelf:authenticatorSettings.setup.qrcodeStep.introduction')}
            </Typography.Text>
            <div style={{ padding: '16px 16px 24px' }}>
                <img alt="qrcode" src={qrcodeUri} style={{ margin: 'auto', display: 'block', maxWidth: '160px' }} />
            </div>

            <ButtonContainer>
                <Button block disabled>
                    {t('userSelf:authenticatorSettings.setup.qrcodeStep.cancelButton')}
                </Button>
                <Button onClick={next} type="primary" block>
                    {t('userSelf:authenticatorSettings.setup.qrcodeStep.submitButton')}
                </Button>
            </ButtonContainer>
        </div>
    );
};

export default QRCodeStep;
